// Auto-ported from the age-of-mcp /gallery. Low-poly parts flattened to a
// self-contained model (no shared helpers, no animations).
import * as THREE from "three";
import { defineModel } from "../../lib";

export const copperRock = defineModel({
  id: "copper-rock",
  batchId: "future",
  name: "Copper rock",
  tags: ["scenery","copper","rock","low-poly","age-of-mcp","future"],
  summary: "Green-streaked copper ore. Smelted to copper — for bronze, tools, wire and coin.",
  description: "Ported from the age-of-mcp gallery (future library).",
  author: "age-of-mcp",
  footprint: 0.46,
  parts: () => [
      { geometry: new THREE.IcosahedronGeometry(0.34, 0), color: "#787b82", position: [0, 0.24, 0], rotation: [0, 0.3, 0.05], scale: [1.1, 0.95, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.2, 0), color: "#6a6d74", position: [0.26, 0.16, 0.08], rotation: [0.1, 1.4, 0], scale: [1, 0.85, 0.95] },
      { geometry: new THREE.IcosahedronGeometry(0.14, 0), color: "#3fae8f", position: [0.08, 0.3, 0.18], rotation: [0.2, 0.4, 0.3], scale: [1.3, 0.35, 1.1] },
      { geometry: new THREE.IcosahedronGeometry(0.11, 0), color: "#52c4a3", position: [-0.14, 0.26, 0.14], rotation: [0.4, 1.1, 0.2], scale: [1.2, 0.4, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.09, 0), color: "#3fae8f", position: [0.04, 0.42, -0.06], rotation: [0.1, 0.7, 0.5], scale: [1.2, 0.4, 1] },
      { geometry: new THREE.TetrahedronGeometry(0.08, 0), color: "#52c4a3", position: [-0.2, 0.34, -0.04], rotation: [0.3, 1.6, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.055, 0), color: "#c2702f", position: [0.18, 0.36, 0.12], rotation: [0.2, 0.5, 0.1] },
      { geometry: new THREE.IcosahedronGeometry(0.045, 0), color: "#dd8a45", position: [-0.04, 0.36, 0.24] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#c2702f", position: [0.12, 0.2, 0.26] },
      { geometry: new THREE.IcosahedronGeometry(0.04, 0), color: "#dd8a45", position: [-0.18, 0.18, 0.18] },
      { geometry: new THREE.TetrahedronGeometry(0.07, 0), color: "#6a6d74", position: [0.2, 0.04, -0.12], rotation: [0.3, 0.8, 0.2] },
      { geometry: new THREE.IcosahedronGeometry(0.06, 0), color: "#3fae8f", position: [-0.19, 0.04, 0.14], rotation: [0.2, 1, 0.3], scale: [1.1, 0.6, 1] },
      { geometry: new THREE.IcosahedronGeometry(0.05, 0), color: "#787b82", position: [0.05, 0.03, -0.21], rotation: [0.2, 0.4, 0.2], scale: [1.1, 0.7, 1] },
    ],
  animations: [],
});
